import {
  $highlight,
  $selections,
  $tempSelection,
  setSelection,
} from '../selection';
import { parseRange } from '@/model/range';
import { useStore } from '@nanostores/react';

export function NameBox() {
  const selections = useStore($selections);
  const highlight = useStore($highlight);
  const temp = useStore($tempSelection);

  let name = '';
  if (temp) {
    name = temp.toString();
  } else if (selections.length === 1) {
    name = selections[0]!.toString();
  } else {
    name = highlight.toExcelString();
  }

  return (
    <div
      className="w-42 rounded border border-gray-400 bg-white p-1 text-sm"
      contentEditable="plaintext-only"
      suppressContentEditableWarning
      spellCheck="false"
      onBlur={e => {
        const range = parseRange(e.currentTarget.textContent!);
        if (range) {
          setSelection(range);
          $highlight.set(range.start);
        } else {
          e.currentTarget.textContent = name;
        }
      }}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          e.currentTarget.blur();
        }
        e.stopPropagation();
      }}
    >
      {name}
    </div>
  );
}
